import { render } from "./Index.vue?vue&type=template&id=15798228"
const script = {}
script.render = render

export default script